import LogList from '@/components/log/list/LogList.vue'

export default {
  name: 'LogGeneral',
  data () {
    return {
      filterValues: {},
      paging: { limit: 50, page: 1, total: 0, pages: 0 }
    }
  },
  components: {
    LogList
  },
  computed: {
    tableFilterConfig () {
      return {
        type: { type: 'select', label: this.$t('log.filters.type'), options: this.logRecordTypeOptions, colOnlyFilter: true },
        date: { type: 'date', label: this.$t('general.filters.datefrom'), colOnlyFilter: true, short: true },
        user: { type: 'userpicker', label: this.$t('log.user'), colOnlyFilter: true }
      }
    },
    logRecordTypeOptions () {
      let options = this.$store.getters.getConfigOptions('log_record_types', this.$i18n.locale);
      options = options.filter(el => (el.code.indexOf('MODEL-') === 0));
      options.unshift({ code: null, text: '' });
      return options;
    }
  },
  methods: {
    clearFilters () {
      this.filterValues.type = null;
      this.filterValues.date = null;
      this.filterValues.user = null;
      this.$refs.logList.reload();
    }
  }

}
